
import Vue from "vue";

export default Vue.extend({
  props: {
    fileName: {
      type: String,
      required: true,
    },
    fileType: {
      type: String,
      required: true,
    },
    fileURL: {
      type: String,
      required: true,
    },
  },
});
